<template>
  <div class="container">
    <button
      class="toggle-btn"
      :class="{ active: value }"
      type="button"
      @click="toggle"
    >
      <span></span>
      <span>{{ label }}</span>
    </button>
  </div>
</template>
<script>
export default {
  name: "NotificationToggle",

  props: {
    value: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      required: true,
    },
  },

  methods: {
    toggle() {
      this.$emit("change", !this.value);
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/less/variables.less";

.container {
  display: flex;
  gap: 10px;
}

.toggle-btn {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  span {
    &:first-child {
      position: relative;
      display: block;
      margin-right: 14px;
      border-radius: 12px;
      min-width: 48px;
      height: 24px;
      background-color: @bg-color-middle;
      transition: @trans;

      &::before {
        content: "";
        position: absolute;
        left: 3px;
        top: 2px;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        background-color: #ffffff;
        transition: @trans;
      }
    }
  }

  &.active {
    span:first-child {
      background-color: @bg-color-dark;

      &::before {
        left: 25px;
      }
    }
  }
}
</style>
